import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import React, { useState, Component } from 'react';
import { toast } from 'react-toastify';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ApiService from '../../../../services/apiService';

const MenuGrid = ({ val, GetMenu }) => {
  const [show, setShow] = useState(false);
  const [id, setId] = useState();
  const [selectedItem, setSelectedItem] = useState(null);

  const handleClose = () => setShow(false);

  const handleShow = (field, item) => {
    setId(field);
    setSelectedItem(item);
    setShow(true);
  };

  const handleDelete = async (id) => {
    const apiService = new ApiService();
    let body = {
      id: parseInt(id),
    };
    let res = await apiService.deleteBody('DELETE_ITEM', body);

    if (res?.data?.statusCode === 204 || res?.data?.statusCode === 200) {
      setShow(false);
      GetMenu();
      toast.success('Item Successfully Deleted');
    } else {
      toast.warning(res?.data?.message || 'Failed to delete item');
    }
  };

  // Price formatter for currency display
  const priceFormatter = (params) => {
    if (params.value) {
      return `$${params.value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
    return '$0.00';
  };

  // Stock status renderer component
  const StockStatusRenderer = (params) => {
    const stock = parseInt(params.value) || 0;
    let statusClass = '';
    let statusText = '';

    if (stock === 0) {
      statusClass = 'stock-out';
      statusText = `Out of Stock (${stock})`;
    } else if (stock <= 10) {
      statusClass = 'stock-low';
      statusText = `Low Stock (${stock})`;
    } else {
      statusClass = 'stock-good';
      statusText = `In Stock (${stock})`;
    }

    return <span className={`stock-badge ${statusClass}`}>{statusText}</span>;
  };

  // Status renderer component for active/inactive
  const StatusRenderer = (params) => {
    const isActive = params.value;
    const statusClass = isActive ? 'status-active' : 'status-inactive';
    const statusText = isActive ? 'Active' : 'Inactive';

    return <span className={`status-badge ${statusClass}`}>{statusText}</span>;
  };

  const [colDefs, setColDefs] = useState([
    {
      headerName: 'Item Name',
      field: 'itemName',
      filter: true,
      floatingFilter: true,
      minWidth: 400,
      cellStyle: { fontWeight: '600', color: '#6E5199' },
    },
    {
      headerName: 'Brand',
      field: 'brand',
      filter: true,
      floatingFilter: true,
      minWidth: 150,
    },
    {
      headerName: 'Category',
      field: 'category',
      filter: true,
      floatingFilter: true,
      minWidth: 150,
    },
    {
      headerName: 'Retail Price',
      field: 'retailPrice',
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      minWidth: 150,
      valueFormatter: priceFormatter,
      cellStyle: { fontWeight: '600', color: '#059669' },
    },
    {
      headerName: 'Wholesale Price',
      field: 'wholesalePrice',
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      minWidth: 150,
      valueFormatter: priceFormatter,
      cellStyle: { color: '#0369a1' },
    },
    {
      headerName: 'Stock Quantity',
      field: 'stockQuantity',
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      minWidth: 150,
      cellRenderer: StockStatusRenderer,
    },
    {
      headerName: 'Tax Rate',
      field: 'taxRate',
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      minWidth: 120,
      valueFormatter: (params) => (params.value ? `${params.value}%` : '0%'),
    },
    {
      headerName: 'Supplier',
      field: 'supplierName',
      filter: true,
      floatingFilter: true,
      minWidth: 200,
    },
    {
      headerName: 'Status',
      field: 'itemStatus',
      filter: true,
      floatingFilter: true,
      minWidth: 120,
      cellRenderer: StatusRenderer,
    },
    {
      headerName: 'Description',
      field: 'description',
      filter: true,
      floatingFilter: true,
      minWidth: 450,
      cellStyle: { textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' },
      tooltipField: 'description',
    },
    {
      headerName: 'Actions',
      field: 'record_Id',
      minWidth: 120,
      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        clicked: function (field, item) {
          handleShow(field, item);
        },
      },
      pinned: 'right',
    },
  ]);

  const frameworkComponents = {
    btnCellRenderer: BtnCellRenderer,
    stockStatusRenderer: StockStatusRenderer,
    statusRenderer: StatusRenderer,
  };

  return (
    <>
      <div className="enhanced-grid-container mt-3">
        <div className="ag-theme-alpine enhanced-ag-grid" style={{ height: '63vh' }}>
          <AgGridReact
            rowData={val}
            columnDefs={colDefs}
            enableFilter={true}
            floatingFilter={true}
            rowSelection="multiple"
            frameworkComponents={frameworkComponents}
            pagination={true}
            paginationPageSize={25}
            suppressRowClickSelection={true}
            rowHeight={50}
            headerHeight={60}
            floatingFiltersHeight={40}
            animateRows={true}
            enableCellTextSelection={true}
            suppressMovableColumns={false}
            defaultColDef={{
              resizable: true,
              sortable: true,
              filter: true,
            }}
          />
        </div>
      </div>

      {/* Enhanced Delete Modal */}
      <Modal show={show} onHide={handleClose} centered className="enhanced-delete-modal">
        <Modal.Header closeButton className="enhanced-modal-header">
          <Modal.Title className="enhanced-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
            Confirm Deletion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="enhanced-modal-body">
          <div className="delete-confirmation">
            <p>Are you sure you want to delete this item?</p>
            {selectedItem && (
              <div className="item-preview-card">
                <img
                  src={selectedItem?.productImage || '/path/to/default-image.jpg'}
                  alt={selectedItem?.itemName}
                  className="preview-image"
                  onError={(e) => {
                    e.target.src = '/path/to/default-image.jpg';
                  }}
                />
                <div className="preview-details">
                  <strong>{selectedItem?.itemName}</strong>
                  <span>{selectedItem?.brand}</span>
                  <span className="preview-price">
                    $
                    {selectedItem?.retailPrice?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) || '0.00'}
                  </span>
                </div>
              </div>
            )}
            <div className="warning-message">
              <strong>⚠️ Warning:</strong> This action cannot be undone.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="enhanced-modal-footer">
          <Button variant="outline-secondary" onClick={handleClose} className="cancel-btn">
            Cancel
          </Button>
          <Button variant="danger" onClick={() => handleDelete(id)} className="confirm-delete-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3,6 5,6 21,6" />
              <path d="m19,6v14a2,2 0 0,1-2,2H7a2,2 0 0,1-2-2V6m3,0V4a2,2 0 0,1,2-2h4a2,2 0 0,1,2,2v2" />
            </svg>
            Delete Item
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx>{`
        /* Enhanced Grid Container */
        .enhanced-grid-container {
          background: white;
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          border: 1px solid #e5e7eb;
        }

        .enhanced-ag-grid {
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid #e5e7eb;
        }

        /* AG Grid Custom Styling */
        .enhanced-ag-grid .ag-header {
          background: linear-gradient(135deg, #6e5199, rgba(110, 81, 153, 0.9));
          color: white;
          font-weight: 600;
        }

        .enhanced-ag-grid .ag-header-cell-label {
          color: white;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          font-size: 12px;
        }

        .enhanced-ag-grid .ag-floating-filter-input {
          border: 1px solid #e5e7eb;
          border-radius: 4px;
          padding: 4px 8px;
        }

        .enhanced-ag-grid .ag-row {
          border-bottom: 1px solid #f3f4f6;
        }

        .enhanced-ag-grid .ag-row:hover {
          background-color: #f9fafb;
        }

        .enhanced-ag-grid .ag-row-even {
          background-color: #fafafa;
        }

        .enhanced-ag-grid .ag-row-odd {
          background-color: white;
        }

        /* Stock Status Badges */
        .stock-badge {
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .stock-badge.stock-good {
          background-color: #dcfce7;
          color: #16a34a;
          border: 1px solid #bbf7d0;
        }

        .stock-badge.stock-low {
          background-color: #fef3c7;
          color: #d97706;
          border: 1px solid #fde68a;
        }

        .stock-badge.stock-out {
          background-color: #fee2e2;
          color: #dc2626;
          border: 1px solid #fecaca;
        }

        /* Status Badges */
        .status-badge {
          padding: 4px 10px;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .status-badge.status-active {
          background-color: #dcfce7;
          color: #16a34a;
          border: 1px solid #bbf7d0;
        }

        .status-badge.status-inactive {
          background-color: #fee2e2;
          color: #dc2626;
          border: 1px solid #fecaca;
        }

        /* Enhanced Delete Button */
        .enhanced-delete-btn {
          background: #dc2626;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .enhanced-delete-btn:hover {
          background: #b91c1c;
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3);
        }

        /* Enhanced Modal Styles */
        .enhanced-delete-modal .modal-content {
          border-radius: 15px;
          border: none;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        .enhanced-modal-header {
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          border-bottom: 1px solid #fecaca;
          padding: 20px 24px;
        }

        .enhanced-modal-title {
          color: #dc2626;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 0;
          font-size: 18px;
        }

        .enhanced-modal-body {
          padding: 24px;
        }

        .delete-confirmation p {
          font-size: 16px;
          color: #374151;
          margin-bottom: 20px;
          text-align: center;
        }

        .item-preview-card {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px;
          background: #f9fafb;
          border-radius: 12px;
          margin-bottom: 16px;
          border: 1px solid #e5e7eb;
        }

        .preview-image {
          width: 60px;
          height: 60px;
          object-fit: cover;
          border-radius: 8px;
          border: 2px solid white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .preview-details {
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex: 1;
        }

        .preview-details strong {
          color: #111827;
          font-size: 16px;
          font-weight: 600;
        }

        .preview-details span {
          color: #6b7280;
          font-size: 14px;
        }

        .preview-price {
          color: #6e5199 !important;
          font-weight: 600 !important;
        }

        .warning-message {
          color: #dc2626;
          background: #fef2f2;
          padding: 12px;
          border-radius: 8px;
          border-left: 4px solid #dc2626;
          font-size: 14px;
          text-align: center;
        }

        .enhanced-modal-footer {
          padding: 16px 24px;
          background: #f9fafb;
          border-top: 1px solid #e5e7eb;
          display: flex;
          gap: 12px;
          justify-content: flex-end;
        }

        .cancel-btn {
          padding: 10px 20px;
          border-radius: 8px;
          font-weight: 600;
          border: 1px solid #d1d5db;
        }

        .confirm-delete-btn {
          padding: 10px 20px;
          border-radius: 8px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          background: #dc2626 !important;
          border: 1px solid #dc2626 !important;
        }

        .confirm-delete-btn:hover {
          background: #b91c1c !important;
          border-color: #b91c1c !important;
        }
      `}</style>
    </>
  );
};

class BtnCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.btnClickedHandler = this.btnClickedHandler.bind(this);
  }

  btnClickedHandler() {
    const { value, clicked, data } = this.props;
    clicked(value, data);
  }

  render() {
    return (
      <button onClick={this.btnClickedHandler} className="enhanced-delete-btn">
        Delete
      </button>
    );
  }
}

export default MenuGrid;
